
































































































import {Component, Vue} from 'vue-property-decorator';
import AppList from '../components/AppList.vue';
import AppSearchFilterSidebar from '../components/AppSearchFilterSidebar.vue';
import AppLoading from '../components/AppLoading.vue';
import {Action, Mutation} from 'vuex-class';
import {ProductReport} from '@/interfaces/ProductReport';
import {eventBus, eventBusEvents} from '@/helpers/eventBusHelper';
import SaveSearchDialog from '@/components/search/SaveSearchDialog.vue';
import ViewSearchDialog from '@/components/search/ViewSearchDialog.vue';
import {Route} from 'vue-router';

@Component({
        name: 'SearchResults',
        components: {
            SaveSearchDialog,
            ViewSearchDialog,
            AppList,
            AppSearchFilterSidebar,
            AppLoading,
        },
    })
    export default class SearchResults extends Vue {
        public $refs!: {
            productReportList: AppList,
            topWrapper: HTMLDivElement,
        };

        @Action('user/addShoppingListRecord') protected addShoppingListRecord!: (brandId: number) => void;
        @Action('user/getShoppingListRecords') protected getShoppingListRecords!: () => void;
        @Action('search/searchForResults')
        protected searchForResults!:
            ({keywords, codes, page, limit}: { keywords: string, codes: string, page: number, limit: number }) => void;

        protected checkAll = false;
        protected activeIndices: number[] = [];
        protected keywords = '';
        protected dialogVisible = false;
        protected duplicates: number[] = [];
        protected isSaveSearchDialogVisible = false;
        protected isViewSearchDialogVisible = false;

        protected get productReportList() {
            return this.$store.getters['search/filteredSearchResults'];
        }

        protected get numberOfReports() {
            return this.$store.getters['search/productSearchResults'].length;
        }

    protected get totalResults() {
        return this.$store.getters['search/totalResults'];
    }

        private isIndeterminate = false;
        private isLoading = false;
        private isButtonEnabled = true;
        private resultsPerPage = 150;
        private isAddingItemsToShoppingList = false;
        private observer: IntersectionObserver | null = null;

        protected handleCheckAllChange(val: boolean) {
            if (this.$refs.productReportList) {
                this.$refs.productReportList.toggleAllIndices(val);
            }
            this.isIndeterminate = false;
        }

        protected async addToShoppingList() {
            this.duplicates = [];
            this.isButtonEnabled = false;
            eventBus.$emit(eventBusEvents.disableNavigation);
            this.isAddingItemsToShoppingList = true;
            const purchasedItemIds = this.$store.getters['user/shoppingListRecords'].map(
                (item: ProductReport) => item.brand);
            for await(const brandId of this.activeIndices) {
                try {
                    await this.addShoppingListRecord(brandId);
                } catch (error) {
                    if (error.response && error.response.status === 422 && purchasedItemIds) {
                        const el = purchasedItemIds.find((element: ProductReport) => element && element.id === brandId);
                        if (el) {
                            this.duplicates.push(Number(el.importId));
                        }
                    }
                }
            }
            await this.getShoppingListRecords();
            this.handleCheckAllChange(false);
            this.isButtonEnabled = true;
            this.isAddingItemsToShoppingList = false;
            eventBus.$emit(eventBusEvents.enableNavigation);
            if (this.duplicates.length) {
                this.dialogVisible = true;
            }

            if (this.duplicates.length !== this.activeIndices.length) {
                this.$message({
                    message: 'Added to shopping list',
                    type: 'success',
                });
            }
        }

        protected onActiveIndicesChange(indices: number[]) {
            this.activeIndices = indices;
            if (this.activeIndices.length === this.productReportList.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        }

        protected onValueChange(value: boolean) {
            this.isIndeterminate = value;
        }

        protected onLoadingToggle(value: boolean) {
            this.isLoading = value;
            if (!value) {
                this.handleCheckAllChange(false);
                this.checkAll = false;
            }
        }

        protected onCommand(command: string) {
            if (command === 'save') {
                this.isSaveSearchDialogVisible = true;
            }
            if (command === 'view') {
                this.isViewSearchDialogVisible = true;
            }
        }

        protected onCloseDialog(type: string) {
            if (type === 'save') {
                this.isSaveSearchDialogVisible = false;
            }
            if (type === 'view') {
                this.isViewSearchDialogVisible = false;
            }
        }

        protected get filteredResultsSubset() {
            return this.productReportList.slice(0, this.resultsPerPage);
        }

        protected mounted() {
            eventBus.$on(eventBusEvents.activateSearchResultLoading, () => {
                this.onLoadingToggle(true);
            });
            eventBus.$on(eventBusEvents.deactivateSearchResultLoading, () => {
                this.onLoadingToggle(false);
            });

            this.observer = new IntersectionObserver(
                ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
                { threshold: [1] },
            );

            this.observer.observe(this.$refs.topWrapper);
        }

        protected destroyed() {
            if(this.observer) {
                this.observer.disconnect();
            }
        }

        protected beforeRouteLeave(to: Route, from: Route, next: any) {
            if (this.isAddingItemsToShoppingList) {
                next(false);
            } else {
                next();
            }
        }
    }
